import { useCallback } from 'react';
import { PolicyTemplate } from '../../../../types/policies';
import { usePatch, UsePatchParams } from '../../../../api/mutations/usePatch';
import { TEMPLATES_BASE_URL } from '../consts';

export type EnablePolicyResponse = PolicyTemplate;

interface EnableTemplateErrorResponse {
    templateId: PolicyTemplate['id'];
    error: string;
}

export type UseEnablePolicyTemplateParams = UsePatchParams<never, EnablePolicyResponse, EnableTemplateErrorResponse>;

export const useEnablePolicyTemplate = (params: UseEnablePolicyTemplateParams) => {
    const { patch, loading, error } = usePatch<never, EnablePolicyResponse, EnableTemplateErrorResponse>(params);

    const enablePolicyTemplate = useCallback(
        (templateId: PolicyTemplate['id']) => patch(`${TEMPLATES_BASE_URL}/${templateId}/enable`),
        [patch]
    );

    return {
        loading,
        error,
        enablePolicyTemplate
    };
};
